<!-- Таб информации по экспедиторской расписке с единым новым представлением титулов. -->
<template>
  <div class="forwarding-info__content">
    <FlowDetails
      v-if="documentFlowVisible"
      :flow="documentFlow"
      :title-details="flowTitleDetails"
      :read-only="readOnly"
      :inspectable="readOnly"
      :variant="variant"
      @title-action="handleTitleAction"
    />

  </div>
</template>

<script>
import FlowDetails from "@/components/Edo/ForwarderReceipt/FlowDetails.vue";

export default {
  name: "EdoForwarderReceiptInfoTab",

  components: {
    FlowDetails,
  },

  props: {
    document: {
      type: Object,
      required: true,
    },
    sabyUrl: {
      type: String,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator: (value) => ["card", "embedded", "flat"].includes(value),
    },
  },

  emits: ["edit-title1", "edit-title2", "edit-receipt"],

  computed: {
    documentData() {
      return this.document.parsed_data || {};
    },

    documentFlow() {
      return this.document.document_flow || {};
    },

    documentFlowVisible() {
      return Array.isArray(this.documentFlow.steps) && this.documentFlow.steps.length > 0;
    },

    flowTitleDetails() {
      const sections = this.commonSections;

      return [{
        key: "receipt",
        label: "Расписка",
        role: "Экспедитор",
        title: "Экспедиторская расписка",
        description: "Подтверждение получения груза экспедитором.",
        hasData: sections.some((section) => section.rows?.length),
        sections,
      }];
    },

    commonSections() {
      return [
        {
          key: "document",
          title: "Документ",
          rows: [
            this.previewRow("document_number", "Номер", this.documentData.document_number || this.document.document_number),
            this.previewRow("document_date", "Дата", this.documentData.document_date || this.document.document_date),
            this.previewRow("contract", "Договор", this.contractLabel),
          ].filter(Boolean),
        },
        {
          key: "participants",
          title: "Участники",
          rows: [
            this.participantRow("client", "Клиент"),
            this.participantRow("expeditor", "Экспедитор"),
            this.participantRow("shipper", "Грузоотправитель"),
            this.participantRow("consignee", "Грузополучатель"),
          ].filter(Boolean),
        },
        {
          key: "route",
          title: "Маршрут",
          rows: [
            this.pointRow("loading_point", "Приём груза"),
            this.pointRow("delivery_point", "Пункт назначения"),
          ].filter(Boolean),
        },
        {
          key: "cargo",
          title: "Груз",
          rows: this.cargoRows,
        },
      ];
    },

    cargoRows() {
      return (this.documentData.cargo_items || []).map((item, index) =>
        this.previewRow(
          `cargo_${index}`,
          `Позиция ${index + 1}`,
          [
            item.title || item.name,
            item.quantity_places ? `${item.quantity_places} мест` : null,
            item.weight_gross_kg ? `${item.weight_gross_kg} кг` : null,
          ].filter(Boolean).join(", ")
        )
      ).filter(Boolean);
    },

    contractLabel() {
      const contract = this.documentData.expedition_contract || {};
      return [contract.name || contract.title, contract.number, contract.date]
        .filter(Boolean)
        .join(" · ");
    },

  },

  methods: {
    previewRow(key, label, value) {
      if (value === null || value === undefined || value === "") return null;
      return { key, label, value };
    },

    participantRow(prefix, label) {
      const participant = this.documentData[prefix] || {};
      return this.previewRow(prefix, label, [
        participant.name,
        participant.inn ? `ИНН ${participant.inn}` : null,
        participant.kpp ? `КПП ${participant.kpp}` : null,
      ].filter(Boolean).join(" · "));
    },

    pointRow(prefix, label) {
      const point = this.documentData[prefix] || {};
      return this.previewRow(prefix, label, [
        point.address,
        point.city,
        point.street,
        point.house,
      ].filter(Boolean).join(", "));
    },

    handleTitleAction({ action }) {
      if (action?.type === "saby" && this.sabyUrl) {
        window.open(this.sabyUrl, "_blank");
      } else if (action?.type === "edit-title1") {
        this.$emit("edit-title1");
      } else if (action?.type === "edit-title2") {
        this.$emit("edit-title2");
      } else if (action?.type === "edit-receipt") {
        this.$emit("edit-receipt");
      }
    },
  },
};
</script>

<style scoped>
.forwarding-info__content {
  display: grid;
  gap: 16px;
}

</style>
